export const T = {
  en_GB: {
    formCompleted: "This form has been completed and submitted. No further changes can be made.",
    cannotSubmit:
      "Cannot submit: Your portfolio contains products that are not suitable based on your risk profile. Please adjust your portfolio to continue.",
    snapshotsStale:
      "Some reference data changed since this form was last opened. Please refresh the snapshots before submitting.",
    snapshotMissing:
      "Portfolio information is missing for one or more goals. Please refresh the snapshots before submitting.",
    refreshSnapshots: "Refresh",
    snapshotsRegenerating:
      "Updating your overview after a change. This usually takes a few seconds; the page refreshes by itself when it is done.",
    snapshotsRefreshFailed: "Failed to refresh snapshots. Please try again.",
    // QL-314 — advisor-review block (kind: "advisor_review"). The flow-level
    // alert lists the goals; the per-goal banner on goal pages uses the
    // reason-specific line for that goal.
    advisorReviewBlocked: "Your advisor needs to review the following before you can submit:",
    advisorReviewTemplate:
      "Your advisor needs to make a change to this flow before you can submit.",
  },
  nb_NO: {
    formCompleted: "Dette skjemaet er fullført og sendt inn. Ingen flere endringer kan gjøres.",
    cannotSubmit:
      "Kan ikke sende inn: Porteføljen din inneholder produkter som ikke er egnet basert på risikoprofilen din. Vennligst juster porteføljen for å fortsette.",
    snapshotsStale:
      "Noe referansedata har endret seg siden dette skjemaet sist ble åpnet. Vennligst oppdater øyeblikksbildene før du sender inn.",
    snapshotMissing:
      "Porteføljeinformasjon mangler for ett eller flere mål. Vennligst oppdater øyeblikksbildene før du sender inn.",
    refreshSnapshots: "Oppdater",
    snapshotsRegenerating:
      "Oppdaterer oversikten etter en endring. Dette tar vanligvis noen sekunder; siden oppdateres av seg selv når det er ferdig.",
    snapshotsRefreshFailed: "Kunne ikke oppdatere øyeblikksbilder. Vennligst prøv igjen.",
    advisorReviewBlocked: "Rådgiveren din må gjennomgå følgende før du kan sende inn:",
    advisorReviewTemplate:
      "Rådgiveren din må gjøre en endring i denne flyten før du kan sende inn.",
  },
} as const;
